<template>
  <div>
    <div class="infoDivClass div_up_class">
      <div class="iip_right">
        <div id="imgNameBox" class="iip_right_t iip_name">{{ imgName }}</div>
        <div class="iip_right_t">畫師: {{ idraw }}</div>
        <div class="iip_right_t">刻工: {{ imark }}</div>

        <div class="iip_right_t">出處: {{ isrc }}</div>
        <div class="iip_right_t">美編: {{ maker }}</div>
        <div class="iip_right_t">發佈時間: {{ publishTime }}</div>

        <div class="iip_right_t titlespan">{{ isrc1 }}</div>
        <div class="iip_right_t titlespan">{{ isrc2 }}</div>
        <div class="iip_right_t titlespan">{{ isrc3 }}</div>
      </div>
      <div class="iip_left">
        <img :src="srcImgUrl" alt="" />
      </div>
    </div>
    <div class="infoDivClass labelInfoClass">{{ label }}</div>
  </div>
</template>

<script>

export default {
  props: {
    imgName: String,
    isrc: String,
    isrc1: String,
    isrc2: String,
    isrc3: String,
    idraw: String,
    imark: String,
    label: String,
    srcImgUrl: String,
    maker: String,
    publishTime: String
  },
  data () {
    return {}
  }
}
</script>

<style scoped lang='less'>
.div_up_class {
  height: 150px;
  display: flex;
  flex-direction: row-reverse;
  .iip_right {
    min-width: 190px;
    display: inline-block;
    height: 100%;
    padding-left: 20px;
    .iip_right_t {
      line-height: 35px;
      color: #fff;
    }
    .iip_name {
      font-weight: 700;
      line-height: 40px;
      font-size: 22px;

    }
    .titlespan {
      padding-left: 30px;
    }
  }
  .iip_left {
    width: auto;
    text-align: center;
    height: 100%;
    padding-top: 0px;
    overflow: hidden;
    display: inline-block;
    img {
      height: 100%;
    }
  }
}
.infoDivClass {
  width: 90%;
  margin-top: 10px;
}
.labelInfoClass {
  color: #fff;
  font-weight: 500;
  text-align: right;
}
</style>
